import useApiClient from "hooks/useApiClient";

const toggleValue = (arr, value) => (arr.includes(value) ? arr.filter((v) => v !== value) : [...arr, value]);

const sectionTitleStyle = {
    fontSize: 14,
    fontWeight: 700,
    marginBottom: 10,
    color: "#0b0b0b",
};

const labelStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    padding: "4px 0",
    fontSize: 13,
};

const FlightCalendarFilters = ({ calendarData, filters, setFilters, isRoundTrip }) => {
    const { urls } = useApiClient();

    const stopLabel = (n) => (n === 0 ? "Direct" : `${n} escale(s)`);

    return (
        <div
            style={{
                backgroundColor: "#fcfcfb",
                borderRadius: 12,
                padding: 20,
                boxShadow: "0 1px 3px rgba(11,11,11,0.10), 0 1px 2px rgba(11,11,11,0.06)",
            }}
        >
            <h5 style={{ marginBottom: 16 }}>Filtres</h5>

            <div style={{ marginBottom: 20, paddingBottom: 20, borderBottom: "1px solid #e1e0d9" }}>
                <div style={sectionTitleStyle}>Escales - Départ</div>
                {calendarData.numberOfStopsOutbound.map((present, stops) =>
                    present ? (
                        <label key={stops} style={labelStyle}>
                            <input
                                type="checkbox"
                                checked={filters.outboundStops.includes(stops)}
                                onChange={() =>
                                    setFilters((prev) => ({ ...prev, outboundStops: toggleValue(prev.outboundStops, stops) }))
                                }
                            />
                            {stopLabel(stops)}
                        </label>
                    ) : null
                )}
            </div>

            {isRoundTrip && (
                <div style={{ marginBottom: 20, paddingBottom: 20, borderBottom: "1px solid #e1e0d9" }}>
                    <div style={sectionTitleStyle}>Escales - Retour</div>
                    {calendarData.numberOfStopsInbound.map((present, stops) =>
                        present ? (
                            <label key={stops} style={labelStyle}>
                                <input
                                    type="checkbox"
                                    checked={filters.inboundStops.includes(stops)}
                                    onChange={() =>
                                        setFilters((prev) => ({ ...prev, inboundStops: toggleValue(prev.inboundStops, stops) }))
                                    }
                                />
                                {stopLabel(stops)}
                            </label>
                        ) : null
                    )}
                </div>
            )}

            <div style={{ marginBottom: 20, paddingBottom: 20, borderBottom: "1px solid #e1e0d9" }}>
                <div style={sectionTitleStyle}>Compagnies</div>
                {calendarData.airlines.map((airline) => (
                    <label key={airline} style={labelStyle}>
                        <input
                            type="checkbox"
                            checked={filters.airlines.includes(airline)}
                            onChange={() => setFilters((prev) => ({ ...prev, airlines: toggleValue(prev.airlines, airline) }))}
                        />
                        <img
                            src={`${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${airline}.png`}
                            alt=""
                            style={{ width: 22, height: 22, objectFit: "contain" }}
                        />
                        {airline}
                    </label>
                ))}
            </div>

            <div>
                <div style={sectionTitleStyle}>Attestation</div>
                <label style={labelStyle}>
                    <input
                        type="checkbox"
                        checked={filters.certificateOnly}
                        onChange={(e) => setFilters((prev) => ({ ...prev, certificateOnly: e.target.checked }))}
                    />
                    Sans Attestation
                </label>
            </div>
        </div>
    );
};

export default FlightCalendarFilters;
